import { createRouter, createWebHistory } from "vue-router";

import { getCurrentUser } from "vuefire";
import * as Sentry from '@sentry/vue';


const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth', // enables smooth scrolling
      }
    }
    return { top: 0 }
  },
  history: createWebHistory(),
  routes: [

    {
      name: "home",
      path: "/",
      component: () => import("/src/pages/Home.vue"),
    },
    {
      name: "embedded",
      path: "/embedded",
      component: () => import("/src/layouts/embedded.vue"),
      children: [
        {
          name: "embedded-home",
          path: "",
          component: () => import("/src/pages/Embedded.vue"),
          props: { isEmbedded: true }
        },
        {
          name: "embedded-register",
          path: "register",
          component: () => import("/src/pages/Register.vue"),
          props: { isEmbedded: true }
        },
        {
          name: "embedded-bodygraph",
          path: "bodygraph",
          component: () => import("/src/pages/Bodygraph.vue"),
          props: { isEmbedded: true, requiresAuth: true }
        }
      ]
    },
    {
      name: "root",
      path: "/:locale?",
      component: () => import("/src/layouts/landing.vue"),
      children: [
        {name: "landing", path: "landing", component: () => import("/src/pages/Landing.vue"),},
        {name: "legal", path: "legal/:type", component: () => import("/src/pages/Legal.vue"),},
      ]
    },
    {
      path: "/user",
      component: () => import("/src/layouts/auth.vue"),
      children: [
        {
          name: "register",
          path: "register",
          alias: "/register",
          component: () => import("/src/pages/Register.vue"),
        },
        {
          name: "register-password-less",
          path: "without-password",
          component: () => import("/src/pages/Anonymously.vue"),
        },
        {
          name: "login",
          path: "login",
          alias: "/login",
          component: () => import("/src/pages/Login.vue"),
        },
        {
          name: "reset-password",
          path: "reset-password",
          component: () => import("/src/pages/ResetPassword.vue"),
        },
        {
          name: "set-password",
          path: "set-password",
          component: () => import("/src/pages/SetPassword.vue"),
        }
      ],
    },
    {
      name: "marketing",
      path: "/pages",
      component: () => import("/src/layouts/mobile.vue"),
      meta: { requiresAuth: true },
      children: [
        {
          name: "marketing-content",
          path: "masterclass",
          component: () => import("/src/pages/MarketingContent.vue"),
          meta: { requiresAuth: true },
        },
      ]
    },
    {
      name: "profile",
      path: "/profile",
      component: () => import("/src/layouts/mobile.vue"),
      meta: { requiresAuth: true },
      children: [
        {
          name: "profile-settings",
          path: "settings",
          component: () => import("/src/pages/ProfileSettings.vue"),
          meta: { requiresAuth: true },
        },
      ]
    },
    {
      name: "reading",
      path: "/reading",
      component: () => import("/src/layouts/mobile.vue"),
      meta: { requiresAuth: true },
      children: [
        {
          name: "bodygraph",
          path: "bodygraph",
          component: () => import("/src/pages/Bodygraph.vue"),
          meta: { requiresAuth: true },
        },
        {
          name: "dashboard",
          path: "dashboard",
          component: () => import("/src/pages/Dashboard.vue"),
          meta: { requiresAuth: true },
        },        
        {
          name: "list",
          path: "list",
          component: () => import("/src/pages/ReadingList.vue"),
          meta: { requiresAuth: true },
        },
        {
          name: "payment-success",
          path: "payment/:session/success",
          component: () => import("/src/pages/PaymentSuccess.vue"),
          meta: { requiresAuth: true },
        },
        {
          name: "reading-upgrade",
          path: "upgrade",
          component: () => import("/src/pages/PremiumUpgrade.vue"),
          meta: { requiresAuth: true },
        },       
        {
          name: "content",
          path: "modules/:module/:part",
          component: () => import("/src/pages/ReadingContent.vue"),
          meta: { requiresAuth: true },
        },
        {
          name: "chapter",
          path: "modules/:module/:part/:chapter",
          component: () => import("/src/pages/ReadingContent.vue"),
          meta: { requiresAuth: true },
        },
      ],
    },
  ],
});

router.beforeEach(async (to, from) => {
  const currentUser = await getCurrentUser();
  
  // Redirect logged-in users from register and login pages to dashboard
  if (currentUser && (to.name === 'register' || to.name === 'login')) {
    return {
      path: "/reading/dashboard"
    };
  }

  if (to.name === 'landing') {
    if(currentUser) {
      return {
        path: "/reading/dashboard",
      }
    }
    else if (to.name === 'login') {
      return '/reading/dashboard';
    }
  } else if (to.meta.requiresAuth) {
    if (!currentUser) {
      return {
        path: "/user/login",
        query: {
          redirect: to.fullPath,
        },
      }
    } else {
      Sentry.setUser({email: currentUser.email});
    }
  }
});

export { router };
